import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, Grid, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import BackgroundShape from '../Assets/Background-Shape.png';
// Custom Icons
import ExhibitorsIcon from '../Assets/Icons/exhibitor.png';
import WebsiteIcon from '../Assets/website-Icon-new.png';
import useUserData from '../hooks/useUserData';
import LoadingPage from './LoadingPage';
import BackWithBreadcrumbAppbar from '../components/BackWithBreadcrumbAppbar';
import SubHeader from '../components/SubHeader';
import LogoSection from '../components/LogoSection';

const Conference = () => {
    const theme = useTheme();
    const mode = theme.palette.mode;
    const { t } = useTranslation();
    const { data } = useUserData();
    const [loading, setLoading] = useState(true);
    let me;
    if (typeof (data?.me) === "string") {
        me = JSON.parse(data?.me);
    } else {
        me = data?.me;
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 2000); // 2 seconds

        return () => clearTimeout(timer);
    }, []);

    const conferenceType = [
        { label: t('StrategicProgram'),  icon: ExhibitorsIcon, link: '/strategic' },
        { label: t('MunicipalWaterProgram'),  icon: ExhibitorsIcon, link: '/municipal' },
        { label: t('Produced/IndustrialWaterProgram'),  icon: ExhibitorsIcon, link: '/produced' },

    ];

    if (loading) {
        return <LoadingPage />
    }

    return (
        <>
            <BackWithBreadcrumbAppbar
                links={[{ label: 'Dashboard', href: '/' }]}
                currentPage={t('conferences')}
            />
            <Box
                sx={{
                    minHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    background: mode === 'light' ? '#2a4b50' : 'inherit',
                    backgroundImage: mode === 'light' ? `url(${BackgroundShape})` : 'none',
                    backgroundBlendMode: 'multiply',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    color: '#fff',
                    paddingY: { xs: 2, sm: 3 },
                }}
            >
                <Container
                    sx={{
                        py: { xs: 2, sm: 2 },
                        px: { xs: 2, sm: 3 },

                    }}
                >
                    {/* Header Section */}
                    <SubHeader />

                    {/* Logo Section */}
                    <LogoSection />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: '0 auto',
                            mb: { xs: 4, sm: 4 }
                        }}
                    >
                        <Typography
                            variant="caption"
                            sx={{
                                fontSize: { xs: '2rem', sm: '1.9rem' },
                                color: '#ffffff',
                                opacity: 1,
                                display: 'block',
                                mb: 2,
                                fontWeight: 900
                            }}
                        >
                            {t('ConferenceProgram')}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            width: '100%',
                            height: '2px',
                            backgroundColor: 'rgba(26,169,139, 1)',
                            margin: '0 auto',
                            mb: { xs: 4, sm: 4 }
                        }}
                    />
                    {/* Menu Grid */}
                    <Grid container spacing={{ xs: 2, sm: 2.5 }} sx={{ mb: 4 }}>
                        {conferenceType.map((item, index) => (
                            <Grid item xs={12} key={`${item.link}-${index}`}>
                                <Link
                                    href={item.link}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'start',
                                        gap: 1,
                                        color: '#ffffff',
                                        textDecoration: 'none',
                                        p: { xs: 2, sm: 2.5 },
                                        border: '2px solid rgba(26,169,139, 1)',
                                        borderRadius: '8px',
                                        height: '100%',
                                        minHeight: '100px',
                                        backgroundColor: 'rgba(76, 212, 192, 0.05)',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            backgroundColor: theme.palette.secondary.main,
                                            transform: 'scale(1.02)',
                                            color: 'rgba(26,169,139, 1)'
                                        },
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={item.icon} alt={item.label} style={{ width: '40px', height: '40px', marginBottom: '12px' }} />
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: "wrap" }}>
                                        <Typography variant="caption" align="center" sx={{ fontSize: '1.5rem', fontWeight: 900, opacity: 1, letterSpacing: '0.2px', color: '#ffffff' }}>
                                            {item.label}
                                        </Typography>
                                    </Box>
                                </Link>
                            </Grid>
                        ))}
                    </Grid>

                    {/* Footer Section */}
                    <Box sx={{ textAlign: 'center', mt: 'auto' }}>

                        <Box
                            sx={{
                                width: '100%',
                                height: '2px',
                                backgroundColor: 'rgba(26,169,139, 1)',
                                margin: '0 auto',
                                mb: { xs: 4, sm: 4 }
                            }}
                        />
                        {/* Website Link */}
                        <Box >
                            <Link
                                href="http://www.omanwaterweek.com"
                                target="_blank"
                                rel="noopener"
                                sx={{
                                    color: '#ffffff',
                                    textDecoration: 'none',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    opacity: 1
                                }}
                            >
                                <img src={WebsiteIcon} alt="Website" style={{ width: "100%", height: '120px', objectFit: "contain", marginBottom: '4px', }} />
                                <Typography sx={{ fontSize: '1.2rem', letterSpacing: '0.3px', color: '#ffffff' }}>
                                    www.omanwaterweek.com
                                </Typography>
                            </Link>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                height: '2px',
                                backgroundColor: 'rgba(26,169,139, 1)',
                                margin: '0 auto',
                                mt: 4
                            }}
                        />
                        {/* Divider */}
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default Conference;
